<template>
<div>

<!-- Modal MESSAGE -->  
<modalMessage ref="msgModal"/>



<!-- Modal -->

  <div v-if="visible" class="modal-backdrop-wrapper">
  <div class="modal d-block" id="productCollections" data-backdrop="static" data-keyboard="false" tabindex="-1"  >
  <div class="modal-dialog modal-dialog-scrollable modal-lg">

    <div class="modal-content">
      <div class="modal-header bg-info">
        <h4 class="modal-title" id="staticBackdropLabel">COLLEZIONI DEL PRODOTTO</h4>
        
      </div>
      <div class="modal-body">
        
        <div class="table-wrapper-scroll-y my-custom-scrollbar">  
        <table class="table table-bordered table-sm">
        <thead>
            <tr>
            <th scope="col">Collezione</th>  
            <th scope="col">Documento</th>
            <th scope="col">Numero</th>
            <th scope="col">Data</th>
            <th scope="col">Colore</th>
            <th scope="col">Misura</th>
            <th scope="col">Prezzo di acquisto</th>
            <th scope="col">Prezzo di vendita</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item,index) in items" :key="index">
                <td>{{item.collezione}} </td>
                <td>{{item.doc}} </td>
                <td>{{item.number}}</td>
                <td>{{item.data}}</td>
                <td>{{item.color}} {{item.supplier_color}}</td>
                <td>{{item.size_list}}</td>
                <td class="text-right">{{item.cost_price}}</td>
                <td class="text-right">{{item.sell_price}}</td>
            </tr>
        </tbody>
        </table>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" @click="visible=false" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>
</div>
</div>

</template>

<script>



import modalMessage                from '@/components/modalDialog/ModalMessage.vue'   
import api from '@/api'
  export default {
  props        : ['productId'],
 components    : {modalMessage},
    data () {
      return {
        
          items   : [],
          visible : false
      
      }
    },
    
    mounted()
    {   
        
        this.getData()
    },
    created () 
      {
      
        //this.getData()
      },
    methods: 
    {
      show()
      {
        this.visible = true
      },
      async getData()
      {

        const data = {'productId' : this.productId}  
        const sp =  'spProductMovementCollection'
        
        const payload = {sp,...data}

          //this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})        
          try{

          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
          
          // this.$refs.msgModal.close()
          
          this.items = res.data.recordsets[0] 
          
                
        }catch(err)
        {
           this.$refs.msgModal.show(err)
        }
        

        


        
  
      },
      
      

      
      

    }
  }
</script>
<style scoped>

.modal-backdrop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050; /* sopra tutto */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5); /* backdrop semi-trasparente */
}
.modal.d-block {
  display: block;
  z-index: 1060; /* sopra il backdrop */
}
  h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}


.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;

    
    
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;

    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.my-custom-scrollbar {
    position  : relative;
    height    : 250px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
</style>
